import Tooltip from "@mui/material/Tooltip";

export default function ToolTipComponent({ children, container, placement }) {
  return (
    <Tooltip arrow placement={placement} title={container}>
      {children}
    </Tooltip>
  );
}
